<template>
  <button
    type="button"
    :class="
      cn([
        'flex gap-1 items-center',
        props.customClass,
        props.class,
        {
          'text-success': checked,
          'inline-flex': props.showText
        }
      ])
    "
    @click="handleCopy"
  >
    <span v-if="props.showText" v-text="props.text" />
    <Icon
      v-if="props.active"
      :name="
        checked
          ? 'material-symbols:library-add-check'
          : 'material-symbols:content-copy-outline'
      "
      :size="props.size"
    />
  </button>
</template>
<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { useClipboard } from '@vueuse/core'

const props = withDefaults(
  defineProps<{
    copied?: boolean
    text: string
    size?: string
    customClass?: HTMLAttributes['class'] // Backward compatibility
    class?: HTMLAttributes['class']
    showText?: boolean
    active?: boolean
    stopPropagation?: boolean
  }>(),
  {
    size: '24px',
    copied: false,
    customClass: '',
    class: '',
    active: true
  }
)

const checked = ref<boolean>(props.copied)
const handleCopy = (e: MouseEvent) => {
  if (props.stopPropagation) e.stopPropagation()
  if (!props.active) return

  const { copy, copied } = useClipboard()
  copy(props.text)
  checked.value = copied.value

  setTimeout(() => {
    checked.value = false
  }, 700)
}
</script>
